import { useMutation, useQuery } from '@tanstack/react-query';
import {
  createTemplateRequest,
  getTemplateRequestData,
  updateTemplateRequest
} from '@/vacancy_request/components/template-request-form/services/api';

export const useTemplateMutation = ({ mode, onHandleSubmitting, onRequestSuccess, onRequestError }) => {
  return useMutation({
    retry: 0,
    mutationFn: (payload) => {
      return mode === 'create'
        ? createTemplateRequest(payload, 'template')
        : updateTemplateRequest(payload, 'template');
    },
    onMutate: () => {
      onHandleSubmitting(true);
    },
    onSuccess: (data) => {
      const { response } = data;

      const isRequestSuccess = response?.success;
      if (!isRequestSuccess) {
        onRequestError(response);
        return;
      }

      onRequestSuccess(response);
    },
    onError: (error) => {
      onRequestError(error);
    },
    onSettled: () => {
      onHandleSubmitting(false);
    }
  });
};

export const useDraftTemplateRequest = ({ mode, onHandleSubmitting, onRequestSuccess, onRequestError }) => {
  return useMutation({
    retry: 0,
    mutationFn: (payload) => {
      return mode === 'create' ? createTemplateRequest(payload, 'draft') : updateTemplateRequest(payload, 'draft');
    },
    onMutate: () => {
      onHandleSubmitting(true);
    },
    onSuccess: (data) => {
      onRequestSuccess(data);
    },
    onError: (error) => {
      onRequestError(error);
    },
    onSettled: () => {
      onHandleSubmitting(false);
    }
  });
};

export const useTemplateRequestData = (templateId) => {
  return useQuery({
    queryKey: ['templateRequest', templateId],
    queryFn: () => getTemplateRequestData(templateId),
    enabled: !!templateId,
    retry: 1,
    staleTime: Infinity
  });
};
